module.exports = __webpack_public_path__ + "static/media/frame-cyan.6d9c79f0.svg";